<template>
  <v-container fluid>
    <page-header>
      <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/courses/management"
          >Course Management</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item
          :to="{ name: 'CourseDetail', params: { id: $route.params.courseId } }"
        >
          {{ course.name }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true">
          Edit Course Info
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>

    <v-card>
    <v-card-text>
    <v-form v-if="course" ref="infoForm" v-model="valid" lazy-validation>
      <v-select
        :items="centers"
        v-model="course.centerId"
        label="Center"
        item-text="name"
        item-value="id"
        :rules="[rules.required]"
        @change="loadPrograms(course.center)"
      />
      <v-select
        :items="programs"
        v-model="course.programId"
        label="Program"
        item-text="name"
        item-value="id"
        :hint="program.description"
        :rules="[rules.required]"
        no-data-text="Choose a center first"
        @change="setCoursePrice"
        clearable
      />
      <v-select
        v-model="course.grade"
        :items="grades"
        item-text="name"
        item-value="value"
        label="Grade"
      ></v-select>
      <v-text-field
        data-cy="nameinput"
        label="Course name"
        v-model="course.name"
        :rules="[rules.required]"
      />
      <v-text-field
        data-cy="descriptionHeading"
        label="Course description heading"
        v-model="course.descriptionHeading"
      />
      <v-textarea
        label="Course description"
        :auto-grow="true"
        rows="1"
        v-model="course.description"
      />
      <!-- <v-select
            v-model="course.subject"
            :items="subjects"
            label="Subject"
          ></v-select> -->
      <v-radio-group
        v-model="course.chargeType"
        :row="true"
        label="Charge by"
        :disabled="true"
        :rules="[rules.required]"
      >
        <v-radio value="Session" label="Session" />
        <v-radio value="Month" label="Monthly" />
        <!-- <v-radio value="Week" label="Weekly" /> -->
        <v-radio value="Course" label="Course" />
      </v-radio-group>
      <v-text-field
        prefix="$"
        :label="`Price per ${course.chargeType}`"
        v-model="course.price"
        :rules="[rules.required]"
      />
      <v-text-field
        type="number"
        min="0"
        max="10"
        label="Max capacity"
        v-model="course.capacity"
      />
      <v-switch
        v-model="course.openEnroll"
        :label="`Open enrollment: ${course.openEnroll ? 'Yes' : 'No'}`"
      ></v-switch>
    </v-form>
    </v-card-text>
    <v-card-actions>
        <slot name="actions">
            <v-spacer />
            <v-btn :to="backRoute">Cancel</v-btn>
            <v-btn color="primary" @click="updateCourse">Update</v-btn>
            <v-spacer />
        </slot>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { rules } from "@/store/util/rules.js";

export default {
  data() {
    return {
      valid: null,
      course: null,
      centers: [],
      programs: [],
      program: {},
      rules,
      backRoute: {name: 'CourseDetail', params: {id: this.$route.params.courseId}}
    };
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading", "grades", "subjects"]),
  },
  methods: {
    ...mapActions([
      "showDialog",
      "hideDialog",
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    async loadCenters() {
      return await this.$axios.get("/center/get-my-centers").then((resp) => {
        this.centers = resp.data;
        return this.centers;
      });
    },
    async loadPrograms(center) {
      const params = { centerId: center };
      return await this.$axios.get("/program/get-by-center", { params }).then((resp) => {
        this.programs = resp.data;
        return this.programs;
      });
    },
    setCoursePrice(programId) {
      console.log(programId);

      this.program = this.programs.find((p) => p.id == programId);

      let payTerm2ChargeType = new Map();
      payTerm2ChargeType["session"] = "Session";
      payTerm2ChargeType["subscription"] = "Month";
      payTerm2ChargeType["flat rate"] = "Course";

      this.course.chargeType = payTerm2ChargeType[this.program.payTerm];
      if (this.program.subject) {
        this.course.subject = this.program.subject;
      }

      if(this.course.capacity == null || this.course.capacity == undefined){
        this.course.capacity = this.program.studentTeacherRatio;
      }

      if(this.course.price == null || this.course.price == undefined){
        this.course.price = this.program.standardRate;
      }

      if (this.course.chargeType == "Session") {
        this.course.pricePerSession = this.course.price;
      } else if (this.course.chargeType == "Week") {
        this.course.pricePerWeek = this.course.price;
      } else if (this.course.chargeType == "Course") {
        this.course.pricePerCourse = this.course.price;
      }
    },
    async initCourse() {
      const courseId = this.$route.params.courseId;
      if (!courseId) {
        return;
      }

      const result = await this.$axios
        .get("classroom/course", {
          params: { courseId },
        })
        .then((resp) => {
          console.log('course:')
          console.log(resp.data)
          this.course = resp.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading course from server");
        });

      return result;
    },
    updateCourse() {
      
      if (this.course.chargeType == "Session") {
        this.course.pricePerSession = this.course.price;
      } else if (this.course.chargeType == "Week") {
        this.course.pricePerWeek = this.course.price;
      } else if (this.course.chargeType == "Course") {
        this.course.pricePerCourse = this.course.price;
      }

      this.course.status = this.course.openEnroll ? "Open Enrollment" : null;
      const data = Object.assign({}, this.course);
      //do not post
      data.owner = null;
      data.courseMaterials = null;
      data.courseOwner = null;
      data.courseSchedules = null;
      data.courseRegistration = null;
      data.courseInvites = null;
      data.courseStudents = null;
      data.courseTeachers = null;
      data.courseTopics = null;
      data.courseWorks = null;

      this.$axios
        .post("course/update", data)
        .then(() => {
          const message = "Successfully updated";
          const messageClass = "success";
          this.$store.dispatch("addMessage", { message, messageClass });
          this.$router.push(this.backRoute)
        })
        .catch((error) => {
          const message = error.data;
          this.addErrorMessage(message);
        });
    },
  },
  mounted() {
    this.initCourse().then(() => {
      this.loadCenters();
      this.loadPrograms(this.course.centerId)
        .then( () => {
          this.setCoursePrice(this.course.programId);
        })
    });
  },
};
</script>

<style>
</style>